import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  //#region Spinner

  /*
   1. Use Given component in main app.component.html file with 'showSpinner' boolean variable

   <mobi-office-lib-loader [loader]="showSpinner" ></mobi-office-lib-loader>

   2. Inject GlobalService from library in app.component.ts and subscribe the 'spinner$' subject as given below.

    this.globalService.getSpinnerObserver().subscribe(status => {
      this.showSpinner = status === "start";
      this.cdRef.detectChanges();
    });

     this.cdRef.detectChanges(); :: Inject 'ChangeDetectorRef' from detect the change of subscription.

  */

  private count: number = 0;
  private spinner$ = new BehaviorSubject<string>("");
  getSpinnerObserver(): Observable<string> {
    return this.spinner$.asObservable();
  }

  requestStarted() {
    if (++this.count === 1) {
      this.spinner$.next("start");
    }
  }

  requestEnded() {
    if (this.count === 0 || --this.count === 0) {
      this.spinner$.next("stop");
    }
  }

  resetSpinner() {
    this.count = 0;
    this.spinner$.next("stop");
  }

  get loadingCount(): number {
    return this.count;
  }

  get loadingStatus(): boolean {
    return this.spinner$.value === "start";
  }

  //#endregion
}
